<template>
    <div class="w-full py-6">
        <div class="flex items-center justify-between">
            <a class="flex-shrink-0 flex-col w-24 text-center text-primary hidden md:flex">
                <span>
                    <font-awesome-icon :icon="['fas', 'user']" class="text-2xl"></font-awesome-icon>
                </span>
                <p class="text-xs font-bold">
                    <font-awesome-icon :icon="['far', 'check-circle']"></font-awesome-icon>
                    Signed up
                </p>
            </a>

            <template v-for="(step, index) in steps">
                <div class="w-full rounded bg-primary-lighter mx-4 hidden md:flex items-start" :key="step.id + '-divider'">
                    <span class="py-1 inline-block rounded bg-primary" :class="currentStep + 1 <= index ? (currentStep + 1 < index ? 'w-0' : 'w-1/3') : 'w-full'"></span>
                </div>

                <div :class="currentStep === index ? 'inline mx-auto' : 'hidden md:inline'" :key="step.id + '-icon'">
                    <a class="flex-shrink-0 flex-col w-24 text-center flex" :class="currentStep < index ? 'text-gray-darker' : 'text-primary'" :key="step.id + '-step'">
                        <span>
                            <font-awesome-icon :icon="['fas', step.icon]" class="text-2xl"></font-awesome-icon>
                        </span>
                        <p class="text-xs font-extralight">
                            <font-awesome-icon :icon="['far', 'check-circle']" v-if="currentStep > index"></font-awesome-icon>
                            {{ step.label }}
                        </p>
                    </a>
                </div>
            </template>
        </div>
            <div class="border border-gray-dark px-8 py-4 mt-8">
                <transition name="slide-fade" mode="out-in">
                    <component :is="steps[currentStep]" @done="stepDone(currentStep)"></component>
                </transition>
            </div>
    </div>
</template>

<script>
import SetupVip from './SetupVip';
import SetupDelivery from './SetupDelivery';
import SetupActivate from './SetupActivate';
import SetupWelcome from './SetupWelcome';
import SetupIntention from './SetupIntention';

export default {
    data() {
        return {
             steps : [
                SetupIntention,
                SetupWelcome,
                SetupDelivery,
                SetupVip,
                SetupActivate,
            ],
            currentStep: 0,
        }
    },
    methods: {
        stepDone(stepIndex) {
            if (stepIndex < this.steps.length - 1) return this.currentStep++;

            window.location = '/';
        }
    }
}
</script>

<style>
.slide-fade-enter-active {
  transition: all .3s ease;
}
.slide-fade-leave-active {
  transition: all .3s cubic-bezier(1.0, 0.5, 0.8, 1.0);
}
.slide-fade-enter, .slide-fade-leave-to {
  transform: translateX(-20px);
  opacity: 0;
}
</style>